/**
 * @packageDocumentation
 * @module StockChartShared
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isNullOrUndefined } from 'util';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { APIMapping } from 'src/app/constants/api-map.cnst';
import { isEmptyField, isEmptyObject } from '../stock-chart-shared-services/stock-chart-util.service';
import { HTTPAPIConfig } from '../stock-chart-shared-models/http-api.config';
import { StockChartDataService } from './stock-chart-data.service';
import { ActivatedRoute } from '@angular/router';
import { APIMapping } from '../../../../constants/StockChart/stock-chart-api-constants';

@Injectable({
  providedIn: 'root'
})
export class StockChartHttpService {

  private API_MAPPING: object = APIMapping;
  private URL_MAPPING: object = environment.urlMapping;
  // private URL_MAPPING: object = {};

  getKeys = Object.keys;

  defaultHTTPConfig: HTTPAPIConfig = {
    method: 'get',
    apiKeyName: 'authenticate',
    postData: {},
    isEntireUrl: false,
    urlString: 'PROJ_API',
    userFieldsToAdd: [],
    routerParamsToAdd: {}
  };

  constructor(
    private http: HttpClient,
    private dataService: StockChartDataService,
    private route: ActivatedRoute
  ) { }

  getOptions(api?: string) {
    const options = {
      headers: {}
    };
    // options.headers['Content-Type'] = 'application/json';
    // options.headers['Access-Control-Allow-Origin'] = '*';
    return options;
  }

  // Deprecated Method need to integrate all to placeAPICall method
  makeApiCall(method: string, apiKeyName: string, postData?: any, urlString: string = 'PROJ_API', isEntireUrl: boolean = false): Observable<any> {
    if (isEmptyField(urlString)) {
      urlString = 'PROJ_API';
    }
    if (isEmptyField(isEntireUrl)) {
      isEntireUrl = false;
    }
    const urlStringMap = this.URL_MAPPING[urlString];
    const apiStatus: any = this.isValidAPICall(apiKeyName, urlStringMap , isEntireUrl);
    // console.log(apiStatus, 'api status here');
    let finalUrl = apiStatus.api;
    if (!isEntireUrl) {
      finalUrl = urlStringMap + apiStatus.api;
    }
    if (apiStatus.valid) {
      return this[method](finalUrl, postData);
    } else {
      return throwError({status: false, msg: apiStatus.msg});
    }
  }

  placeAPICall(config: HTTPAPIConfig): Observable<any> {
    let actualConfig: HTTPAPIConfig = this.dataService.deepMerge(this.defaultHTTPConfig, config);
    if (isEmptyField(actualConfig.urlString)) {
      actualConfig.urlString = 'PROJ_API';
    }
    if (isEmptyField(actualConfig.isEntireUrl)) {
      actualConfig.isEntireUrl = false;
    }
    // if (!isEmptyField(config.userFieldsToAdd)) {
    //   actualConfig.postData = this.httpUtilService.addUserFields(config.userFieldsToAdd, actualConfig.postData);
    // }
    if (!isEmptyObject(config.routerParamsToAdd)) {
      actualConfig.postData = this.addRouteFields(config.routerParamsToAdd, actualConfig.postData);
    }
    const urlStringMap = this.URL_MAPPING[actualConfig.urlString];
    const apiStatus: any = this.isValidAPICall(actualConfig.apiKeyName, urlStringMap , actualConfig.isEntireUrl);
    // console.log(apiStatus, 'api status here',"\n URL_MAPPING ",this.URL_MAPPING," \n actualConfig ", actualConfig);
    let finalUrl = apiStatus.api;
    if (!actualConfig.isEntireUrl) {
      finalUrl = urlStringMap + apiStatus.api;
    }
    if (apiStatus.valid) {
      return this[actualConfig.method](finalUrl, actualConfig.postData);
    } else {
      return throwError({status: false, msg: apiStatus.msg});
    }
  }




  post(url: string, postData: any): Observable<any> {
    return this.http.post(url , postData, this.getOptions());
  }

  multipart(url: string, postData: any): Observable<any> {
    const fd = new FormData();
    for (const key of this.getKeys(postData)) {
      fd.append(key, postData[key]);
    }
    return this.http.post(url, fd);
  }

  get(url: string, postData: any ): Observable<any> {
    for (const val in postData) {
      if (url.indexOf(val)) {
        url = url.replace( new RegExp(val, 'g'), postData[val]);
      }
    }
    return this.http.get(url, this.getOptions());
  }

  isValidAPICall(api: string, url: string, isEntireUrl: boolean): object {
    if (isEntireUrl) {
      return {valid: true, api: this.API_MAPPING[api]};
    }
    if (!isNullOrUndefined(this.API_MAPPING)) {
      const currentApi = this.API_MAPPING[api];
      if (!isNullOrUndefined(currentApi)) {
        return {valid: true, api: currentApi};
      } else {
        console.log('API_MAPPING not found for for ' + api + '..Please update API_MAPPING in Project Constants (ProjConst)');
        return {valid: false, msg: 'API_MAPPING not found for ' + api};
      }
    } else {
      console.log('API_MAPPING not found in Project Constants (ProjConst)');
      return {valid: false, msg: 'API_MAPPING not found in Project Constants (ProjConst)'};
    }
  }

  addRouteFields(routerConfig, postData) {
    if (!isEmptyObject(routerConfig.queryParams)) {
      for (let param of Object.keys(routerConfig.queryParams)) {
        postData[routerConfig.queryParams[param]] = this.route.snapshot.queryParams[param];
      }
    }
    if (!isEmptyObject(routerConfig.params)) {
      for (let param of Object.keys(routerConfig.params)) {
        postData[routerConfig.params[param]] = this.route.snapshot.params[param];
      }
    }
    return postData;
  }
}

